import type { LaunchpadClickEvent } from '$lib/services/tracking/googleAnalytics/events';
import { track } from '$lib/services/tracking/googleAnalytics';

export function trackLaunchpadClick(action: LaunchpadClickEvent['action']) {
	track({
		action,
		payload: {
			action: 'click',
			context: 'launchpad',
		},
	});
}
